var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'line-chart': true,
    bb: true,
    dense: _vm.density > _vm.HIGH,
    sparse: _vm.density < _vm.LOW,
    'density-medium': _vm.density > _vm.MEDIUM,
  }})}
var staticRenderFns = []

export { render, staticRenderFns }